import * as Yup from "yup";
import React, {useCallback, useEffect, useState} from "react";
import {makeRequired, makeValidate} from "mui-rff";
import {Col, Row} from "reactstrap";
import Dialog from "../../base/dialog";
import {DialogContent, DialogTitle} from "@mui/material";
import Form from "../../base/form";
import {OutlinedInputForm} from "../../base/input/outlined_input";
import Button from "../../base/button/button";
import Api from "../../../../core/services/api/api";
import useIsMounted from "../../../hooks/use-is-mounted";

const initialSchema = Yup.object().shape({
    note: Yup.string().trim().nullable(),
});


const UpdateLookupAnalyticsReviewNoteDialog = ({open, close, log, onSuccess}) => {
    const [initialValues, setInitialValues] = useState({});
    const [loading, setLoading] = useState(false);
    const validate = makeValidate(initialSchema);
    const required = makeRequired(initialSchema);
    const isMounted = useIsMounted();

    /**
     * Listens for when the modal opens and closes, and if open, gets the list of
     */
    useEffect(() => {
        if (!open) {
            setLoading(false);
            return;
        }
        setInitialValues({note: log?.reviewNote ?? ''});
    }, [log?.reviewNote, open])

    /**
     * Registers a new vendor into the system.
     * @param values
     */
    const onSubmit = useCallback(async (values) => {
        setLoading(true);
        const trimmedNote = values.note?.trim() ?? '';
        const forApi = {
            reviewNote: trimmedNote.length ? trimmedNote : null,
            id: log?.id,
        }
        const response = await Api.updateNexusLogReviewNote(forApi);
        if (!isMounted()) return;
        setLoading(false);
        if (response?.resultFlag) {
            onSuccess(response?.data ?? {});
            close();
        }
    }, [close, isMounted, log?.id, onSuccess])


    const colClass = 'px-3 mb-4';
    return (
        <Dialog
            open={open}
            setOpen={close}
            maxWidth={'md'}
        >
            <DialogTitle>
                <Row xs={12} className='no-gutters justify-content-center w-100'>
                    <p className={`text-lg text-color-1 my-2 font-weight-semi-bold text-center`}>
                        Set Review Note
                    </p>
                </Row>
            </DialogTitle>
            <DialogContent dividers className={'pb-0 px-0'}>
                <div className='my-2 w-100'/>
                <Form
                    id={'submission-form'}
                    className='w-100'
                    onSubmit={onSubmit}
                    validate={validate}
                    initialValues={initialValues}
                    render={({values}) => {
                        return (
                            <Row className='no-gutters justify-content-around w-100'>
                                <Row className={'no-gutters w-100 justify-content-start'}>
                                    <Col xs={12} className={colClass}>
                                        <OutlinedInputForm
                                            label={'Note'}
                                            name={'note'}
                                            type={'text'}
                                            multiline
                                            minRows={15}
                                            required={required.note}
                                        />
                                    </Col>
                                </Row>
                                <div className='my-1 w-100'/>
                                <Row className={'justify-content-between align-items-start w-100 p-0'}>
                                    <Button
                                        disabled={!open}
                                        variant={'dialog'}
                                        color={'primary'}
                                        onClick={() => close()}
                                        borderRadius={'0 8px 0 8px'}
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        disabled={!open || loading || (values?.note === initialValues?.note)}
                                        variant={'dialog'}
                                        color={'primary'}
                                        form={'submission-form'}
                                        type={'submit'}
                                        borderRadius={'8px 0 8px 0'}
                                    >
                                        {!loading ? 'Save' : 'Processing...'}
                                    </Button>
                                </Row>
                            </Row>
                        );
                    }}
                />
            </DialogContent>
        </Dialog>
    );
}

export default UpdateLookupAnalyticsReviewNoteDialog;
